import * as React from "react";
import { forwardRef, memo } from "react";
const SvgEdit = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M200-200h56l345-345-56-56-345 345zm572-403L602-771l56-56q23-23 56.5-23t56.5 23l56 56q23 23 24 55.5T829-660zM160-120q-17 0-28.5-11.5T120-160v-113q0-8 3-15.5t9-13.5l412-412 170 170-412 412q-6 6-13.5 9t-15.5 3zm413-453-28-28 56 56z" })));
const ForwardRef = forwardRef(SvgEdit);
const Memo = memo(ForwardRef);
export default Memo;
